import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { EmailTemplates } from "../models/orders/emailTemplates";
import { GetPurchaseOrderConfirmationJournalRequest } from "../models/orders/getPurchaseOrderConfirmationJournalRequest";
import { POEmailLogs } from "../models/orders/poEmailLogs";
import { SalesOrderBCInformationDto } from "../models/orders/salesOrderBCInformation";
import { VendorInformationForPOEmailDto } from "../models/orders/vendorInformationForPOEmailDto";
import { FileUploadDto } from "../models/shared/fileUploadDto";
import { GetPurchaseOrderConfirmationJournalResponseDto } from "../models/orders/getPurchaseOrderConformationResponseDto";

@Injectable({
  providedIn: "root",
})
export class PoEmailService {
  private saleOrderManagementBaseURL =
    environment.baseUrl + "/SalesOrderManagement";
  private d365SynchroniserBaseURL = environment.baseUrl + "/D365Synchroniser";
  private commonBaseURL = environment.baseUrl + "/Common";
  private fileManagementBaseURL = environment.baseUrl + "/fileManagement";
  private samplepoManagementBaseURL =
    environment.baseUrl + "/SamplePOMangement";
  constructor(private _http: HttpClient) {}

  getEmailTemplatesByType(
    type: string
  ): Observable<GenericResponseDto<EmailTemplates[]>> {
    return this._http.get<GenericResponseDto<EmailTemplates[]>>(
      `${this.commonBaseURL}/GetEmailTemplatesByType?type=${type}`
    );
  }

  getSalesOrderBCInformation(
    salesOrderId: string
  ): Observable<GenericResponseDto<SalesOrderBCInformationDto>> {
    return this._http.get<GenericResponseDto<SalesOrderBCInformationDto>>(
      `${this.saleOrderManagementBaseURL}/GetSalesOrderBCInformation?SaleOrderId=${salesOrderId}`
    );
  }

  getVendorInformationForPOEmail(
    poNumber: string
  ): Observable<GenericResponseDto<VendorInformationForPOEmailDto>> {
    return this._http.get<GenericResponseDto<VendorInformationForPOEmailDto>>(
      `${this.samplepoManagementBaseURL}/GetVendorInformationForPOEmail?poNumber=${poNumber}`
    );
  }

  createPOEmailLogs(
    poEmailLogs: POEmailLogs
  ): Observable<GenericResponseDto<POEmailLogs>> {
    return this._http.post<GenericResponseDto<POEmailLogs>>(
      `${this.saleOrderManagementBaseURL}/CreatePOEmailLogs`,
      poEmailLogs
    );
  }

  GetPurchaseOrderConfirmationJournal(
    payload: GetPurchaseOrderConfirmationJournalRequest
  ): Observable<
    GenericResponseDto<GetPurchaseOrderConfirmationJournalResponseDto>
  > {
    return this._http.post<
      GenericResponseDto<GetPurchaseOrderConfirmationJournalResponseDto>
    >(
      `${this.d365SynchroniserBaseURL}/GetPurchaseOrderConfirmationJournal`,
      payload
    );
  }

  getPoEmailAttachmentUrl(
    fileObj: FileUploadDto
  ): Observable<GenericResponseDto<string>> {
    return this._http.post<GenericResponseDto<string>>(
      this.fileManagementBaseURL + "/upload",
      fileObj
    );
  }
}
